import { useLocation, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import ProfileSidebar from './ProfileSidebar/ProfileSidebar';
import { ProfileLayoutProps, ProfilePages } from './ProfileLayout.types';
import '../../../styles/Profile.css';

export default ({ children, ...props }: ProfileLayoutProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentView, setCurrentView] = useState<ProfilePages>(ProfilePages.Home);

  useEffect(() => {
    const [, namespace, repository] = location.pathname.split('/');
    const pathExists = Boolean(Object.values(ProfilePages).find((page) => page === repository));
    if (pathExists) {
      setCurrentView(repository as ProfilePages);
    } else if (namespace === 'profile') {
      setCurrentView(ProfilePages.Home);
    } else {
      navigate('/profile');
    }
  });

  return (
    <div className="profile">
      <ProfileSidebar {...{ currentView }} />
      <div className="profile__main" {...props}>
        {children}
      </div>
    </div>
  );
};
